import { useLanguage } from './LanguageContext'
import { translations, Language, t } from './translations'

export function useTranslation() {
  const { lang } = useLanguage()

  const translate = (key: string): string => {
    return t(key, lang)
  }

  // Get nested translation object
  const getObject = (key: string): any => {
    const keys = key.split('.')
    let value: any = translations

    for (const k of keys) {
      if (value && typeof value === 'object' && k in value) {
        value = value[k]
      } else {
        return null
      }
    }

    return value
  }

  // Get array of translations (for benefits, etc.)
  const getArray = (key: string): string[] => {
    const obj = getObject(key)
    if (obj && Array.isArray(obj[lang])) {
      return obj[lang]
    }
    return []
  }

  return { t: translate, lang, getObject, getArray }
}
